import React, { useState, useEffect } from "react";
import Sidebar from "../Layout/ClientSidebar";
import Navbar from "../Layout/Navbar";
import OrdersTable from "./OrdersTable";

const OrdersPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Check for screen size to collapse sidebar on small screens
  useEffect(() => {
    // Function to check screen width and update the sidebar state
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Collapse sidebar on small devices
      } else {
        setIsSidebarOpen(true); // Keep sidebar open on larger devices
      }
    };

    // Call handleResize initially
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array to run only on component mount and unmount

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      <div className="flex flex-1 w-full">
        {/* Sidebar */}
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

        {/* Main content area */}
        <div
          className={`flex-1 p-2 transition-all overflow-hidden duration-300 ease-in-out ${
            isSidebarOpen ? "md:ml-52 ml-0" : "ml-0"
          }`}
        >
          {/* Navbar */}
          <Navbar toggleSidebar={toggleSidebar} />
          {/* <br /> */}

          {/* Orders Table */}
          <div className="content flex-1 max-w-full min-h-screen">
            <OrdersTable />
          </div>

          {/* Responsive Footer */}
          <footer className="bg-gray-800 text-white text-center sm:text-right p-2 mt-4 shrink-0 w-full rounded-md">
            <p className="text-sm">
              Designed with ❤️ and crafted with care by Team{" "}
              <a
                href="https://www.youtube.com/@SHALENDERSINGH"
                target="_blank"
                rel="noopener noreferrer"
                className="text-yellow-500 font-bold block sm:inline hover:text-yellow-600"
              >
                SMART ITBOX
              </a>
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default OrdersPage;
